import { Box } from '@veracity/vui'

import { PageContainer, PageSearchInput } from '@/components'
import { useCurrentUser, useFilterDatasets } from '@/hooks'

import {
  AddOtherBessInputsDatasetDialog,
  OtherBessInputsDatasetsTable
} from './components'
import { useOtherBessInputs } from './hooks'

export const OtherBessInputsPage = () => {
  const { isUser } = useCurrentUser()
  const { datasets, isFetching } = useOtherBessInputs()
  const { filteredDatasets, onFilterChange } = useFilterDatasets(datasets)

  return (
    <PageContainer
      loading={isFetching}
      header={
        <PageContainer.Breadcrumbs
          items={[{ title: 'Library' }, { title: 'Other BESS Inputs' }]}
        />
      }
      menuBar={
        <Box justify="space-between" w="100%">
          <PageSearchInput onChange={onFilterChange} />
          {isUser && <AddOtherBessInputsDatasetDialog />}
        </Box>
      }>
      <OtherBessInputsDatasetsTable datasets={filteredDatasets} />
    </PageContainer>
  )
}
